import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, Grid, Typography, Box, Button, TextField, Pagination, Stack, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { Link } from "react-router-dom";
import { Crumbs } from "../Crumbs";
import { Helmet } from "react-helmet";
import SubNav from "./Community/SubNav";

const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];
const PAGE_SIZE = 12;

export const ArtistListPage = () => {
    const [artists, setArtists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [sort, setSort] = useState("name:asc");

    useEffect(() => {
        setLoading(true);
        let url = `${BACKEND_HOST}/artists?pagination[pageSize]=${PAGE_SIZE}&pagination[page]=${page}&sort[0]=${sort}`;
        if (search) {
            url += `&filters[name][$contains]=${search}`;
        }
        fetch(url)
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data.data)) {
                    setArtists(data.data);
                    setTotal(data.meta?.pagination?.total || data.data.length);
                } else {
                    setArtists(data.data || []);
                    setTotal(data.total || data.data?.length || 0);
                }
                setLoading(false);
            });
    }, [search, page, sort]);

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleSortChange = (e) => {
        setSort(e.target.value);
        setPage(1);
    };

    const pageCount = Math.ceil(total / PAGE_SIZE);

    const desc = "The best bands to dance to in Austin!";
    const title = "2-Step band directory";

    const meta = <Helmet>
                <title>{title}</title>
                <meta name="description" content={desc} />
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href={"/community"}/>
            </Helmet>

    return (
        <Box>
            {meta}
            <Box>
                <Crumbs crumbs={[ 
                    { title: "Community", href: "/community" },
                    { title: "Artists" }
                ]} />
            </Box>
            <SubNav />
            <Box mb={3}>
                <Box fullWidth textAlign="center" pt={3}>
                    The best bands to dance to in Austin!
                </Box>
                <Box fullWidth textAlign="center"  my={5}>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <TextField
                            label="Search Artists"
                            value={search}
                            onChange={handleSearchChange}
                            variant="outlined"
                            size="small"
                        />
                        <FormControl size="small" variant="outlined">
                            <InputLabel id="sort-label">Sort By</InputLabel>
                            <Select
                                labelId="sort-label"
                                value={sort}
                                onChange={handleSortChange}
                                label="Sort By"
                            >
                                <MenuItem value="name:asc">Name (A-Z)</MenuItem>
                                <MenuItem value="name:desc">Name (Z-A)</MenuItem>
                              
                            </Select>
                        </FormControl>
                    </Stack>
                </Box>
                {loading ? (
                    <Typography>Loading...</Typography>
                ) : (
                    <>
                        <Grid container spacing={2}>
                            {artists.map((artist, idx) => (
                                <Grid item xs={12} md={6} lg={4} key={artist.id || idx}>
                                    <Card>
                                        <CardHeader
                                            title={artist?.name || artist?.attributes?.name || "Unknown Artist"}
                                            subheader={artist?.tag || artist?.attributes?.tag || ""}
                                        />
                                        <CardContent>
                                            <Typography variant="body2" color="textSecondary">
                                                {artist?.venmo || artist?.attributes?.venmo || ""}
                                            </Typography>
                                            <Box mt={2}>
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    component={Link}
                                                    to={`/artist/${artist.artistKey || artist.id}`}
                                                >
                                                    View Artist
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        {pageCount > 1 && (
                            <Box mt={4} display="flex" justifyContent="center">
                                <Pagination
                                    count={pageCount}
                                    page={page}
                                    onChange={(_, value) => setPage(value)}
                                    color="primary"
                                />
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </Box>
    );
};
